import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { VideosListSorter } from '../../../../models';

export type VideoSortOption = {
  label: string;
  meta: VideosListSorter;
  value: string;
};

const videoSortFilterOptions: VideoSortOption[] = [
  { label: 'Latest', meta: { createdAt: 'descend' }, value: 'latest_created' },
  { label: 'Oldest', meta: { createdAt: 'ascend' }, value: 'oldest_created' },
  { label: 'Name (A-Z)', meta: { name: 'ascend' }, value: 'alphabetical' },
];

export const useVideoSortFilterOptions = () => {
  const { t } = useTranslation();

  return useMemo(() => videoSortFilterOptions.map((option) => ({ ...option, label: t(option.label) })), [t]);
};
